import React from 'react';
import { Row, Col, Accordion } from 'react-bootstrap'; // Используем Accordion

function ActivitiesContent() {
  return (
    <Row>
      <Col>
        <h1>Деятельность</h1>

        <Accordion defaultActiveKey="0">
          <Accordion.Item eventKey="0">
            <Accordion.Header>Музыкальная школа Екатерины Заборонок</Accordion.Header>
            <Accordion.Body>
              <p>Моя деятельность связана с музыкальным образованием для взрослых. Взрослые воплощают свои давние творческие мечты. Музыкальная школа для взрослых Екатерины Заборонок помогаем и направляем их. Уверена, что Петь и Играть сможет каждый!</p>
              <p>Я открыта для творческих контактов, идей и предложений. Буду рада сотрудничеству.</p>

              <ul>
                <li>организую выступлений солистов, ансамблей, хоров. любые концертные номера</li>
                <li>веду уроки дирижирования для начинающих на канале Youtube,</li>
                <li>организую семинары, мастер-классы по эстрадному и академическому вокалу</li>
                <li>руковожу "Хором Модерато"</li>
                <li>руковожу эстрадным вокальным ансамблем "Flickers"</li>
                <li>пишу аранжировки и переложения для ансамблей и хоров</li>
                <li>пишу каверы для групп</li>
                <li>пишу музыку</li>
                <li>организую хоровые фестивали. С 2012 года мы проводим хоровые фестивали "Осеннее многоголосье" и "Тебе, Россия, наши песни"</li>
                <li>организую мероприятия с участием профессиональных артистов</li>
              </ul>

              <p>Музыкальная школа для взрослых Екатерины Заборонок может предложить вам:</p>
              <ul>
                <li>обучение вокалу (индивидуально и в группах)</li>
                <li>обучение сольфеджио</li>
                <li>обучение игре на инструменте (индивидуально и в группах)</li>
                <li>запись ваших песен (запись на студии с профессиональным качественным обордованием</li>
                <li>аранжировка ваших песен</li>
                <li>"коллектив на праздник" - коллективы Школы являются украшением любого мероприятия, поднимают жизненный тонус и настраивают гостей на хороший лад</li>
                <li>Школа проводит бесплатные консультации по всем дисциплинам! На консультациях мы помогаем человеку определиться и более четко сформулировать его музыкальное желание и стремление, подсказываем в каком направлении ему следует развиваться, вдохновляем на подвиги и музыкальные свершения.</li>
                <li>Сайт "Музыкальной школы для взрослых Екатерины Заборонок" - <a href="https://musicschool.moscow">musicschool.moscow</a></li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="1">
            <Accordion.Header>Репетиционная база "Территория музыки" Екатерины Заборонок г.Москва</Accordion.Header>
            <Accordion.Body>
              <p>Репетиционная база "Территория музыки" Екатерины Заборонок г.Москва</p>
              <ul>
                <li>аренда классов 22м2</li>
                <li>аренда зала 100м2</li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>

        <div className="mt-3"> {/* Отступ сверху для ссылок */}
          <h2>Полезные ссылки:</h2>
          <ul>
            <li><a href="https://vk.com/ekaterinazaboronok">ВКонтакте</a></li>
            <li><a href="https://www.facebook.com/ekaterinazaboronok">Facebook</a></li>
            <li><a href="https://musicschool.moscow">Сайт Музыкальной школы</a></li>
            <li><a href="https://vk.com/musicschool.moscow">ВКонтакте Музыкальной школы</a></li>
            <li><a href="https://vk.com/musrepetit">ВКонтакте "Территория музыки"</a></li>
            <li><a href="https://vk.com/hormoderato">ВКонтакте "Хор Модерато"</a></li>
            <li><a href="https://www.facebook.com/musicschool.moscow">Facebook Музыкальной школы</a></li>
            <li><a href="https://www.facebook.com/groups/musrep.ru">Facebook "Территория музыки"</a></li>
            <li><a href="https://www.youtube.com/channel/UCGoiHn2pq7kbDIAvq9JiRqg">Youtube канал</a></li>
          </ul>
        </div>

      </Col>
    </Row>
  );
}

export default ActivitiesContent;